export default "__VITE_ASSET__CTMdQytM__"